/**
 * WiseFlow.js
 *
 * Wise international bank account onboarding.
 * Uses Wise Platform API — no per-user profile creation needed.
 * Goes straight to country-specific bank account form.
 *
 * Props:
 *   country    {string}   ISO-3166-alpha2 country code selected in WalletDialog
 *   isCreator  {bool}     Creator vs business user context
 *   onSuccess  {function} Called with serialized GUWallet on completion
 *   onError    {function} Called with error message string on failure
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import WiseRecipientForm from './WiseRecipientForm';

export default function WiseFlow({ country, isCreator, onSuccess, onError }) {
  return (
    <Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant="caption" color="text.secondary">
          Powered by Wise — secure international bank transfers
        </Typography>
      </Box>
      <WiseRecipientForm
        key={country}
        country={country}
        onComplete={onSuccess}
        onError={onError}
      />
    </Box>
  );
}
